export default __webpack_public_path__ + "static/media/icon--github.38e30528.svg";